import React from "react";
import { Link } from "react-router-dom";
import FieldMerger from "../../components-admin/FieldMerger/FieldMerger";
import FirebaseFunctionsRunner from "../../components-admin/FirebaseFunctionsRunner/FirebaseFunctionsRunner";
import MappingDebugger from "../../components-admin/MappingDebugger/MappingDebugger";
import ImportVCDataForm from "../../components/ImportVCDataForm/ImportVCDataForm";
import LoadingMask from "../../components/LoadingMask/LoadingMask";
import { useAppAuthState } from "../../hooks/use-app-auth-state";
import { useDocumentTitle } from "../../hooks/use-document-title";
import { useRedirectIfNotAdmin } from "../../hooks/use-redirect-if-not-admin";
import "./AdminPage.scss";

const AdminPage: React.FC = () => {
  useDocumentTitle("Admin");
  useRedirectIfNotAdmin();

  const { fireUser, isAuthLoading, isUserAdmin } = useAppAuthState();
  if (isAuthLoading || !isUserAdmin || !fireUser) {
    return <LoadingMask message="Loading admin page..." />;
  }

  return (
    <div className="admin-home-page">
      <div className="page-header">Admin</div>

      <div className="row">
        <div className="col-lg-8">
          <MappingDebugger />
          <FieldMerger />
        </div>
        <div className="col-lg-4 sidebar">
          <div className="inner">
            <ImportVCDataForm fireUser={fireUser} />
            <FirebaseFunctionsRunner />
            <hr />
            <div className="admin-links">
              <Link to="/admin/carts">Carts</Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminPage;
